if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target
            .closest('.parent-display')
            .querySelector('.show-more-item');
          if (
            nextElementToFocus &&
            !nextElementToFocus.classList.contains('hidden') &&
            nextElementToFocus.querySelector('input')
          ) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target
          .closest('[id^="Show-More-"]')
          .closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) =>
          element.classList.toggle('hidden'),
        );
        parentDisplay
          .querySelectorAll('.show-more-item')
          .forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    },
  );
}


  document.addEventListener('DOMContentLoaded', function () {
    const quantityInput = document.querySelector('.quantity-selector__input');
    const table = document.getElementById('quantity-price-break-table');

    function updateHighlight() {
      if (!table || !quantityInput) return;
      const quantity = parseInt(quantityInput.value, 10);
      const rows = table.querySelectorAll('tbody tr');
      let bestMatch = null;

      rows.forEach(row => {
        row.style.backgroundColor = ''; // Reset all rows
        const rowQuantity = parseInt(row.getAttribute('data-quantity'), 10);
        if (quantity >= rowQuantity) {
          bestMatch = row;
        }
      });

      if (bestMatch) {
        bestMatch.style.backgroundColor = 'lightgreen'; // Highlight best match
      }
    }

    // Listen for input changes
    if (quantityInput) {
      quantityInput.addEventListener('input', updateHighlight);
    }

    // Listen for button clicks
    const minusButton = document.querySelector('[data-quantity-minus]');
    const plusButton = document.querySelector('[data-quantity-plus]');

    if (minusButton) {
      minusButton.addEventListener('click', function () {
        setTimeout(updateHighlight, 0); // Wait for input value to update
      });
    }

    if (plusButton) {
      plusButton.addEventListener('click', function () {
        setTimeout(updateHighlight, 0); // Wait for input value to update
      });
    }

    // Initial call to set highlight on page load
    updateHighlight();
  });

/* START AUGUST 2025 CALIFORNIA GEO IP */
(function() {
  // ====== Config ======
  var GEOIP_ENDPOINT = "https://api.ipgeolocation.io/ipgeo?apiKey=9dbe31905c264d5cb1666b65a4a68419";

  // ====== Cookie helpers ======
  function setCookie(name, value, hours) {
    var d = new Date();
    d.setTime(d.getTime() + (hours*60*60*1000));
    document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + d.toUTCString() + ";path=/;SameSite=Lax";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
    }
    return null;
  }

  // ====== Text match helpers ======
  function textIncludes(el, needle) {
    if (!el) return false;
    var txt = (el.textContent || "").toLowerCase().trim();
    return txt.indexOf(needle) !== -1;
  }

  function textExcludes(el, needle) {
    if (!el) return true;
    var txt = (el.textContent || "").toLowerCase().trim();
    return txt.indexOf(needle) === -1;
  }

  // ====== Hiding logic ======
  var isCA = false;
  var observer = null;

  function hideTargetsInRoot(root) {
    if (!isCA) return;

    // Hide any links whose visible text contains "Inspo"
    var anchors = (root.querySelectorAll ? root.querySelectorAll("a") : []);
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      if (a.__geoHidden) continue;
      if (textIncludes(a, "inspo") && textExcludes(a,"#")) {
        a.style.display = "none";
        a.__geoHidden = true;
      }
      var text = (a.textContent || "").trim().toLowerCase();
      var href = (a.getAttribute("href") || "").toLowerCase();

      if (text === "inspiration" && href === "/blogs/inspiration") {
        // do something, for example hide it
        a.style.display = "none";
        a.__geoHidden = true;
      }
    }

    // Hide any div.accordion-item that contains a button with "Inspiration"
    var items = (root.querySelectorAll ? root.querySelectorAll("div.accordion-item") : []);
    for (var j = 0; j < items.length; j++) {
      var item = items[j];
      if (item.__geoHidden) continue;
      var btns = item.querySelectorAll("button");
      var shouldHide = false;
      for (var k = 0; k < btns.length; k++) {
        if (textIncludes(btns[k], "inspiration")) {
          shouldHide = true;
          break;
        }
      }
      if (shouldHide) {
        item.style.display = "none";
        item.__geoHidden = true;
      }
    }
  }

  function startObserver() {
    if (observer) return;
    observer = new MutationObserver(function(mutations) {
      if (!isCA) return;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var n = 0; n < m.addedNodes.length; n++) {
          var node = m.addedNodes[n];
          if (node.nodeType !== 1) continue;
          hideTargetsInRoot(node);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function applyHidingNowAndObserve() {
    isCA = true;
    hideTargetsInRoot(document);
    startObserver();
  }

  // ====== Bootstrap flow ======
  var cached = getCookie("geo_state");
  if (cached) {
    if (cached.toLowerCase() === "california" || cached.toLowerCase() === "ca") {
      applyHidingNowAndObserve();
    }
  } else {
    try {
      startObserver();
      fetch(GEOIP_ENDPOINT, { cache: "no-store" })
        .then(function(res){ return res.ok ? res.json() : Promise.reject(); })
        .then(function(data){
          var region = (data && data.state_prov) ? String(data.state_prov) : "";
          if (!region) throw new Error("No state");
          setCookie("geo_state", region, 72);
          if (region.toLowerCase() === "california") {
            applyHidingNowAndObserve();
          }
        })
        .catch(function(){ /* Silent fail */ });
    } catch(e) {}
  }

  document.addEventListener("DOMContentLoaded", function(){
    if (isCA) hideTargetsInRoot(document);
  });
})();
/* END AUGUST 2025 CALIFORNIA GEO IP */

/* START FAST SIMON CA-SPECIFIC CODE FOR NO RESULTS PAGE */
function hooks() {
  // simple cookie reader
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
    }
    return null;
  }

  function findProductsGrid(el) {
    if (!el) return document.getElementById("products-grid");
    if (el.id === "products-grid") return el;
    var grid = el.querySelector ? el.querySelector("#products-grid") : null;
    if (!grid && el.closest) grid = el.closest("#products-grid");
    if (!grid) {
      var fsParent = el.closest ? el.closest("#fs-serp-page") : null;
      if (fsParent) grid = fsParent.querySelector("#products-grid");
    }
    return grid || document.getElementById("products-grid");
  }

  // replace with <div data-rebuy-id="230253"></div>
  function replaceProductsGridIn(el) {
    var grid = findProductsGrid(el);
    if (!grid || grid.__geoReplaced) return false;
    var repl = document.createElement("div");
    repl.setAttribute("data-rebuy-id", "230253");
    grid.replaceWith(repl);
    grid.__geoReplaced = true;
    return true;
  }

  function ensureCaliforniaCheck(el) {
    var state = getCookie("geo_state");
    if (state && /^(california|ca)$/i.test(state)) {
      replaceProductsGridIn(el);
      return true;
    }
    return false;
  }

  function runCaliforniaGuard(el) {
    if (ensureCaliforniaCheck(el)) return;
    var tries = 0, maxTries = 20;
    var iv = setInterval(function () {
      tries++;
      if (ensureCaliforniaCheck(el) || tries >= maxTries) clearInterval(iv);
    }, 500);
  }

  window.SerpOptions.registerHook("serp-product-grid", function ({ data, element }) {
    var fsParent = element.closest("#fs-serp-page");
    if (fsParent && window.location.pathname.includes("/collections") && fsParent.querySelector(".fs-no-results")) {
      console.log("NO RESULTS!");
      runCaliforniaGuard(element);
    }
  });
}

if (window.SerpOptions) {
  hooks();
} else {
  window.addEventListener("fast-serp-ready", function () { hooks(); });
}
/* END FAST SIMON CA-SPECIFIC CODE FOR NO RESULTS PAGE */